export * from "./change-password.modal";



// WEBPACK FOOTER //
// ./src/app/admin/all-users/change-password-modal/index.ts